import LocationService from '@/components/location-select/service';

export default {
  components: {
  },
  data() {
    return {};
  },
  created() {
  },
  methods: {
    lazyLoad(node, resolve) {
      let { level, value } = node;
      let areaCode = level === 0 ? this.currentAreaCode : value;
      let length = areaCode.length;
      if (length >= 12) {
        resolve();
        return;
      }
      LocationService.getLocationList(areaCode).then(res => {
        if (res) {
          if (length >= 9) {
            res.result.filter(item => item.id).map(item => item.leaf = true);
          }
          resolve(res.result.filter(item => item.id));
        };
      });
    },
    splitCode (currentLevel, arr = [], maxLevel, code) {
      if (currentLevel > maxLevel) {return arr;}
      if (currentLevel <=3) {
        if (code.length > 2) {
          arr.push(code.substr(0, currentLevel * 2));
          this.splitCode(++currentLevel, arr, maxLevel, code);
        } else {
          arr.push(code);
        }
        return arr;
      } else {
        arr.push(code.substr(0, (currentLevel - 3) * 3 + 6));
        this.splitCode(++currentLevel, arr, maxLevel, code);
        return arr;
      }
    },
    getIdLevel (id) {
      if (id === '00') {return 0;}
      const beforeStr = id.substr(0, 6);
      const afterStr = id.slice(6);
      let level = 1;
      if (afterStr) {
        level = afterStr.length / 3 + 3;
      } else {
        level = beforeStr.length / 2;
      }
      return level;
    }
  }
};
